import NotificationsHistoryPage from "components/pages/NotificationsHistoryPage";

export default function CaptureNotifiLimHistory(props) {
    return <NotificationsHistoryPage />
}